document.addEventListener('DOMContentLoaded', (event) => {
    
    var slideIndex = 0;


    $('.compare-block-slider').slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        nextArrow: '<button type="button" class="slick-button-next" aria-label="Next">' + window.assets.icon_right + '</button>',
        prevArrow: '<button type="button" class="slick-button-prev" aria-label="Previous">' + window.assets.icon_left + '</button>',
        responsive: [{
                breakpoint: 990,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 569,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    function addSlide(div) {
        $('.compare-block-slider').slick('slickAdd', div);
    }

    $('body').on("click", ".compare-block a.remove", function(e) {
        e.preventDefault();
        e.stopPropagation();
  
        $('.compare-action input[data-product-id="' + $(this).parents('.item').data('product-id') + '"]').prop('checked', false);
        $('.compare-action input[data-product-id="' + $(this).parents('.item').data('product-id') + '"]').trigger('change');
        $(this).closest('.slick-slide').remove();

        $('.compare-block-slider').slick('reinit');
      

        setCompareCookieGrid();

    });
    $('body').on('change', '.compare-action input', function() {
        if (this.checked) {
            addCompareItem($(this));
        } else {
            $('.compare-block .items #item_' + $(this).data('product-id')).remove();
        }
       
        setCompareCookieGrid();
    });
    $('body').on("click", ".toggle-compare", function(e) {
        $('.toggle-compare span').text('Hide Compare');
        $('.toggle-compare').removeClass('show-btn');
        $('.compare-block').toggleClass('active');
        if (!$('.compare-block').hasClass("active")) {
            $('.toggle-compare span').text('Show Compare');
            $('.toggle-compare').addClass('show-btn');
        }
    });

    if (getCookie("compare_product_ids")) {
        var compare_product_ids = getCookie("compare_product_ids");
        var array_id = compare_product_ids.split("|");
        for (var k in array_id) {
            slideIndex++;
            if ($('.compare-action input[data-product-id="' + array_id[k] + '"]')) {
                $('.compare-action input[data-product-id="' + array_id[k] + '"]').prop('checked', true);
                $('.compare-action input[data-product-id="' + array_id[k] + '"]').trigger('change');
            }
        }
    }

 
});